export const DEFAULT_LETTER_PAGE = 'letters-dashboard';

export const LETTER_PAGE_ROUTES: Record<string, string> = {
  'letters-dashboard': '/dashboard',
  'letters-create': '/create',
  'letters-create-fresh': '/create/fresh',
  'letters-upload-pdf': '/upload-pdf',
  'letters-create-template': '/templates/create',
  'letters-view-templates': '/templates',
  'letters-view': '/view',
  'letters-drafts': '/drafts',
  'letters-pending-approval': '/approval',
  'letters-admin': '/admin',
  'letters-role-assignment': '/admin/roles',
  'letters-add-signature': '/admin/signatures',
};

const ROUTE_PAGE_ALIASES: Record<string, string> = {
  '/': DEFAULT_LETTER_PAGE,
  '/letters': 'letters-view',
  '/letters/dashboard': DEFAULT_LETTER_PAGE,
  '/letters/create': 'letters-create',
  '/letters/view': 'letters-view',
};

const normalizePath = (pathname: string) => {
  const path = `/${String(pathname || '').replace(/^\/+/, '').replace(/\/+$/, '')}`;
  return path === '/.' ? '/' : path;
};

export const isKnownLetterPage = (page?: string | null) => !!page && page in LETTER_PAGE_ROUTES;

export const getLetterPathForPage = (page?: string | null) => {
  if (page && LETTER_PAGE_ROUTES[page]) return LETTER_PAGE_ROUTES[page];
  return LETTER_PAGE_ROUTES[DEFAULT_LETTER_PAGE];
};

export const getLetterPageFromPath = (pathname: string) => {
  const path = normalizePath(pathname);
  if (ROUTE_PAGE_ALIASES[path]) return ROUTE_PAGE_ALIASES[path];

  const routeMatch = Object.entries(LETTER_PAGE_ROUTES).find(([, route]) => route === path);
  if (routeMatch) return routeMatch[0];

  const legacyPage = path.slice(1);
  if (isKnownLetterPage(legacyPage)) return legacyPage;

  return null;
};

export const buildLetterRouteSearch = (extraParams?: Record<string, string | number | null | undefined> | URLSearchParams) => {
  const params = extraParams instanceof URLSearchParams
    ? new URLSearchParams(extraParams)
    : new URLSearchParams();

  if (!(extraParams instanceof URLSearchParams) && extraParams) {
    Object.entries(extraParams).forEach(([key, value]) => {
      if (value !== null && value !== undefined && String(value) !== '') {
        params.set(key, String(value));
      }
    });
  }

  params.delete('page');
  return params.toString();
};

export const buildLetterRouteUrl = (
  origin: string,
  page?: string | null,
  extraParams?: Record<string, string | number | null | undefined> | URLSearchParams,
) => {
  const path = getLetterPathForPage(page);
  const search = buildLetterRouteSearch(extraParams);
  return `${origin.replace(/\/+$/, '')}${path}${search ? `?${search}` : ''}`;
};